import { Chip, ChipProps } from "@mui/material"
import { handleCutStringHelper } from "../../../../helpers/displayStringHelpers"

interface IChipFilter extends ChipProps{
    title: string,
    gteValue?: number,
    lteValue?: number,
    enumValue?: any[],
    minValue?: number,
    maxValue?: number,
    str?: string,
    prefix?: string
    type: "number" | "date" | "enum" | "string"
    onClick: () => void
}

const ChipFilter: React.FC<IChipFilter> = (props) => {

    const getDateLabel = () => {
        if (props.gteValue !== undefined && props.lteValue !== undefined)
            return  props.title + ": " + new Date(props.gteValue).toLocaleString('en-GB', { timeZone: "UTC" }) + "  -  "
                + new Date(props.lteValue).toLocaleString('en-GB', { timeZone: "UTC" })
        if (props.gteValue === undefined && props.lteValue !== undefined)
            return props.title + ": > " + new Date(props.lteValue).toLocaleString('en-GB', { timeZone: "UTC" })
        if (props.gteValue !== undefined && props.lteValue === undefined)
            return props.title + ": < " +  new Date(props.gteValue).toLocaleString('en-GB', { timeZone: "UTC" })
    }

    const getNumberLabel = () => {
        if (props.gteValue !== undefined && props.lteValue !== undefined)
            return  props.title + ": " + props.gteValue.toString() + "-" + props.lteValue.toString()
        if (props.gteValue === undefined && props.lteValue !== undefined)
            return props.title + ": " + (props.minValue ?? "0") + "-" + props.lteValue.toString()
        if (props.gteValue !== undefined && props.lteValue === undefined)
            return props.title + ": " + props.gteValue.toString() + "-" + (props.maxValue ?? "255")
    }

    const getEnumLabel = () => {
        if (props.enumValue && props.enumValue.length > 0) {
            let str: string = ""
            props.enumValue.forEach((e) => {
                if (str !== "") str += ", "
                str = str + handleCutStringHelper(props.prefix, e.toString())
            })
            return props.title + ": " + str
        }
    }

    const getStringLabel = () => {
        if (props.str && props.str.length !== 0) {
            return props.title + ": " + props.str
        }
    }

    const getLabel = () => {
        switch (props.type) {
            case "number":
                return getNumberLabel()
            case "date":
                return getDateLabel()
            case "enum":
                return getEnumLabel()
            case "string":
                return getStringLabel()
        }
    }

    return (
        (props.gteValue === undefined && props.lteValue === undefined) &&
        (props.enumValue === undefined || props.enumValue?.length <= 0) &&
        (props.str === undefined || props.str.length === 0)? null
            : <Chip style={{marginLeft: "0.5rem"}} label={getLabel()} onDelete={props.onClick} />
    )
}

export default ChipFilter